// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70888":"96be3df2","79258":"96be3df2","84570":"96be3df2"}[chunkId] + ".chunk.css";
};